<div class="bg-second-level p-5 rounded-lg h-full flex flex-col overflow-hidden">
  <div
    class="bg-[#B1B6DC] text-indigo-900 px-3 py-1 -mx-5 -mt-5 mb-4 font-bold text-center text-xs uppercase tracking-wider"
  >
    Non-HR System
  </div>

  <div class="grow flex flex-col justify-center">
    <div class="mb-4" [class.text-center]="centered()">
      @let nonHrModule = moduleNonHrSystemRecording();
      <h4
        class="text-lg font-semibold mb-0 truncate"
        [class.text-center]="centered()"
        [pTooltip]="nonHrModule.nonHrToolProviderName"
        tooltipPosition="top"
      >
        {{ nonHrModule.nonHrToolProviderName }}
      </h4>
      <p
        class="text-sm opacity-80 truncate"
        [pTooltip]="nonHrModule.nonHrToolName"
        tooltipPosition="top"
      >
        {{ nonHrModule.nonHrToolName }}
      </p>
    </div>

    <div>
      <h5 class="text-sm opacity-60 mb-3" [class.text-center]="centered()">
        {{ 'common.functions' | transloco }} ({{ moduleFunctionsCount() }}):
      </h5>
      <div class="space-y-1">
        @for (nonHrModuleFunction of moduleFunctionSystemRecordings(); track $index) {
          <div class="flex items-center gap-2">
            <div class="w-1.5 h-1.5 rounded-full shrink-0 bg-indigo-400"></div>
            <span class="text-sm">
              {{
                moduleFunctionTranslations(nonHrModuleFunction.systemDirectusUuid)
                  | translateDirectus
              }}
            </span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
